import { Outlet, NavLink } from 'react-router-dom'
import { UserButton } from '@clerk/clerk-react'

const navItems = [
  { to: '/', label: '概览', icon: '🏠' },
  { to: '/tracking', label: '每日追踪', icon: '⏱' },
  { to: '/error-book', label: '错题本', icon: '📝' },
  { to: '/review-queue', label: '遗复', icon: '🔄' },
  { to: '/review', label: '复盘', icon: '📋' },
]

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* 顶部栏 */}
      <header className="sticky top-0 z-40 bg-white/80 dark:bg-ink-dark/80 backdrop-blur border-b border-ink-200 dark:border-ink-400">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
          <span className="font-bold">高考学习平台</span>
          <UserButton afterSignOutUrl="/" />
        </div>
      </header>

      <div className="flex-1 flex">
        {/* 侧边栏 - 桌面 */}
        <nav className="hidden md:flex flex-col w-48 border-r border-ink-200 dark:border-ink-400 p-3 gap-1">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-accent/10 text-accent font-medium'
                    : 'hover:bg-ink-100 dark:hover:bg-ink-500'
                }`
              }
            >
              <span>{item.icon}</span>
              <span className="text-sm">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* 主内容 */}
        <main className="flex-1 overflow-auto pb-20 md:pb-0">
          <Outlet />
        </main>
      </div>

      {/* 底部导航 - 移动 */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-ink-dark border-t border-ink-200 dark:border-ink-400 z-40">
        <div className="flex justify-around py-2">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 px-2 py-1 text-xs ${
                  isActive ? 'text-accent' : 'text-ink-500'
                }`
              }
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  )
}
